import React from "react"
import { useTranslation } from "react-i18next"

import type { DateTime } from "luxon"

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers-pro"
import { AdapterLuxon } from "@mui/x-date-pickers-pro/AdapterLuxon"

import type { YearPickerProps } from "./year-picker.types"

export const YearPicker: React.FC<YearPickerProps> = ({
  availableDateRange,
  isDisabled,
  onChange,
  value,
}) => {
  const { i18n, t } = useTranslation("common")
  const [error, setError] = React.useState(false)

  const handleChange = (date: DateTime | null) => {
    if (
      date &&
      availableDateRange?.isValid &&
      availableDateRange.contains(date)
    ) {
      onChange(date)
    }
  }

  return (
    <LocalizationProvider
      adapterLocale={i18n.language}
      dateAdapter={AdapterLuxon}
    >
      <DatePicker
        defaultValue={value}
        disabled={isDisabled ?? !value}
        maxDate={availableDateRange?.end ?? undefined}
        minDate={availableDateRange?.start ?? undefined}
        onChange={handleChange}
        onError={(newError) => {
          setError(Boolean(newError))
        }}
        slotProps={{
          textField: {
            helperText:
              error && !isDisabled ? t("validation.dateYearOutOfRange") : null,
            size: "small",
            slotProps: {
              htmlInput: { "aria-label": "Year" },
            },
          },
        }}
        sx={{ width: 148 }}
        value={value}
        views={["year"]}
      />
    </LocalizationProvider>
  )
}
